import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const HandleSignin: React.FC<{}> = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const redirectUrl = sessionStorage.getItem('redirect');

    navigate(redirectUrl === '/signin' ? '/' : redirectUrl || '/');
  }, []);

  return null;
};
